import * as PIXI from 'pixi.js';
import * as _ from 'lodash';

import Utils from '@/assets/js/Utils';
import GameManager from '@/assets/js/game/GameManager';
import TextureManager from '@/assets/js/game/TextureManager';

const SPRITE_WIDTH = 27;
const SPRITE_HEIGHT = 27;
const REMOVE_POSITION_Y = 800;
const REMOVE_ANGLE = 45;
const SPEED = 1;
const GENERATE_LENGTH = 9;
const GENERATE_INTERVAL = 100;

let stage, spriteList, timer;

export default class MutekiAnimation {
  static init(parentStage) {
    stage = parentStage;
    spriteList = [];
  }

  static start() {
    timer = setInterval(() => {
      _.times(GENERATE_LENGTH).map(() => MutekiAnimation.generate());
    }, GENERATE_INTERVAL);
  }

  static stop() {
    if (timer) clearInterval(timer);
  }

  static generate() {
    const key = _.sample(['star_white', 'star_yellow']);
    const texture = TextureManager.get(key);
    const sprite = new PIXI.Sprite(texture);
    const randomX = GameManager.calcRatio(_.random(GameManager.gameWidth));
    const x = randomX - sprite.width * 0.5;
    const y = 0;

    sprite.width = GameManager.calcRatio(SPRITE_WIDTH);
    sprite.height = GameManager.calcRatio(SPRITE_HEIGHT);
    sprite.x = x;
    sprite.y = y;
    sprite.startPosition = { x: x, y: y };
    sprite.goalX = _.random(sprite.x - 10, sprite.x + 10);
    sprite.angle = _.random(360);
    sprite.startAngle = sprite.angle;
    sprite.totalTime = 0;
    sprite.isRemove = false;
    sprite.speed = _.random(0.4, SPEED);

    stage.addChild(sprite);

    spriteList.push(sprite);
  }

  static update(delta) {
    if (spriteList.length <= 0) return;
    _.forEach(spriteList, (sprite, index) => {
      sprite.totalTime += delta;
      let timeFraction = Utils.msToSecond(sprite.totalTime) / sprite.speed;
      if (timeFraction > 1) timeFraction = 1;
      const progress = Utils.timing('linear', timeFraction);
      MutekiAnimation.draw(sprite, progress);

      if (timeFraction >= 1) {
        sprite.isRemove = true;
        stage.removeChild(sprite);
      }
    });
    _.remove(spriteList, sprite => sprite.isRemove);
  }

  static draw(sprite, progress) {
    const goalX = sprite.goalX - sprite.width * 0.5;
    const goalY =
      GameManager.calcRatio(REMOVE_POSITION_Y) - sprite.height * 0.5;

    const distanceX = goalX - sprite.startPosition.x;
    const distanceY = goalY - sprite.startPosition.y;

    sprite.x = sprite.startPosition.x + distanceX * progress;
    sprite.y = sprite.startPosition.y + distanceY * progress;
    sprite.angle = sprite.startAngle + REMOVE_ANGLE * progress;
  }
}
